import Logline from "logline";
import queryString from "query-string";
import { formatDatetime } from "@js/utils";

Logline.keep(0.5);

const appLog = new Logline("chikii-web");

const _log = console.log;
const _error = console.error;
const _debug = console.debug;

const shouldOuputLog =
  process.env.NODE_ENV == "development" || location.href.indexOf("alpha") > -1;
const param = queryString.parse(location.search);
const env = process.env.enviroment;

if (!param.debug && env != "development" && env != "pre") {
  console.error = (...args) => {
    _error.apply(console, args);
  };

  console.log = (...args) => {
    // Do something with the log message
    shouldOuputLog && _log.apply(console, args);
  };

  console.debug = (...args) => {
    // do something with the warn message
    shouldOuputLog && _debug.apply(console, args);
  };
}

export default {
  log: function (msg: unknown) {
    try {
      appLog.info(msg);
    } catch (e) {
      console.log(e);
    }
  },
  warning: function (msg: unknown) {
    try {
      appLog.warning(msg);
    } catch (e) {
      console.log(e);
    }
  },
  debug: function (msg: unknown) {
    try {
      appLog.critical(msg);
    } catch (e) {
      console.log(e);
    }
  },
  error: function (msg: unknown) {
    try {
      appLog.error(msg);
    } catch (e) {
      console.log(e);
    }
  },
  allLogs: function (callback: (logs: string) => void) {
    try {
      Logline.all(function (logs: unknown) {
        const strArr: string[] = [];
        if (Array.isArray(logs)) {
          logs.forEach((item) => {
            const timeObj = formatDatetime(Number(item.time));
            strArr.push(
              `${timeObj.hour}:${timeObj.minute}:${timeObj.second}\t${item.descriptor}\n`
            );
          });
        }
        callback && callback(strArr.join(""));
      });
    } catch (e) {
      console.log("allLogs error", e);
      callback && callback("");
    }
  },
};
